import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee, { Problema } from "@/components/landing/Marquee";
import { Solucion } from "@/components/landing/Solucion";
import Autoridad from "@/components/landing/Autoridad";
import Beneficios from "@/components/landing/Beneficios";
import LeadMagnet from "@/components/landing/LeadMagnet";
import Contacto from "@/components/landing/Contacto";
import Footer from "@/components/landing/Footer";
import WhatsappFab from "@/components/landing/WhatsappFab";

const Home = () => {
    return (
        <main data-testid="home-page" className="relative min-h-screen bg-[#F7F3EE]">
            <Navbar />
            <Hero />
            <Marquee />
            <Problema />
            <Solucion />
            <Autoridad />
            <Beneficios />
            <LeadMagnet />
            <Contacto />
            <Footer />
            <WhatsappFab />
        </main>
    );
};

function App() {
    return (
        <div className="App">
            <Toaster
                position="top-center"
                toastOptions={{
                    style: {
                        background: "#1E1E1E",
                        color: "#F7F3EE",
                        border: "1px solid rgba(247,243,238,0.12)",
                        fontFamily: "Outfit, sans-serif",
                        borderRadius: "4px",
                    },
                }}
            />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
